import { createStore } from '@shared/utils/state/state-factory'
import type { IndividualKycView } from './individual-kyc-view'

/** Where the signatory form leads once the link is sent: back to the page, or to the timeline. */
type SignatoryFormNext = 'close' | 'started' | 'progress'

type IndiaKycDialog =
  | { kind: 'chooser' }
  | { kind: 'individual'; startAt?: IndividualKycView }
  | { kind: 'upgrade' }
  | { kind: 'business'; next: SignatoryFormNext }
  | { kind: 'progress'; isJustStarted?: boolean }

interface IndiaKycDialogState {
  dialog: IndiaKycDialog | null
  openChooser: () => void
  openIndividual: (startAt?: IndividualKycView) => void
  /** An individual account's step up: what business KYC adds, before the signatory form. */
  openUpgrade: () => void
  /** The authorised signatory form that starts the first business KYC. */
  openBusiness: (next?: SignatoryFormNext) => void
  /** The business KYC's timeline; `isJustStarted` right after the signatory form sent the link. */
  openProgress: (isJustStarted?: boolean) => void
  closeDialog: () => void
}

// Not the gate's own state: an approval lifts the gate and the success screen has to outlive it,
// so the app shell hosts the dialogs (`IndiaKycDialogsHost`).
export const useIndiaKycDialogStore = createStore<IndiaKycDialogState>('indiaKycDialog', (set) => ({
  dialog: null,
  openChooser: () => set({ dialog: { kind: 'chooser' } }),
  openIndividual: (startAt) => set({ dialog: { kind: 'individual', startAt } }),
  openUpgrade: () => set({ dialog: { kind: 'upgrade' } }),
  openBusiness: (next = 'close') => set({ dialog: { kind: 'business', next } }),
  openProgress: (isJustStarted) => set({ dialog: { kind: 'progress', isJustStarted } }),
  closeDialog: () => set({ dialog: null }),
}))
